"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));
var libphonenumber_js_1 = require("libphonenumber-js");
dayjs_1.default.extend(relativeTime_1.default);
/**
 * Predicate with type guard, used to filter out null or undefined values
 * in a filter operation.
 */
function notNullOrUndefined(val) {
    return val !== undefined && val !== null;
}
exports.notNullOrUndefined = notNullOrUndefined;
/**
 * Used in exhaustiveness checks to assert a codepath should never be reached.
 */
function assertNever(value) {
    throw new Error("Expected never, got " + typeof value);
}
exports.assertNever = assertNever;
/**
 * Simple object check.
 * From https://stackoverflow.com/a/34749873/772859
 */
function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
exports.isObject = isObject;
function isClassInstance(item) {
    return isObject(item) && item.constructor.name !== 'Object';
}
exports.isClassInstance = isClassInstance;
/**
 * Given an array of option arrays `[['red, 'blue'], ['small', 'large']]`, this method returns a new array
 * containing all the combinations of those options:
 *
 * @example
 * ```
 * generateAllCombinations([['red, 'blue'], ['small', 'large']]);
 * // =>
 * // [
 * //  ['red', 'small'],
 * //  ['red', 'large'],
 * //  ['blue', 'small'],
 * //  ['blue', 'large'],
 * // ]
 */
function generateAllCombinations(optionGroups, combination, k, output) {
    if (combination === void 0) { combination = []; }
    if (k === void 0) { k = 0; }
    if (output === void 0) { output = []; }
    if (k === 0) {
        optionGroups = optionGroups.filter(function (g) { return 0 < g.length; });
    }
    if (k === optionGroups.length) {
        output.push(combination);
        return [];
    }
    else {
        // tslint:disable:prefer-for-of
        for (var i = 0; i < optionGroups[k].length; i++) {
            generateAllCombinations(optionGroups, combination.concat(optionGroups[k][i]), k + 1, output);
        }
        // tslint:enable:prefer-for-of
        return output;
    }
}
exports.generateAllCombinations = generateAllCombinations;
function formatPhoneNumber(value) {
    var phoneNumber = libphonenumber_js_1.parsePhoneNumberFromString(value);
    if (phoneNumber) {
        return phoneNumber.formatInternational();
    }
    else {
        return '';
    }
}
exports.formatPhoneNumber = formatPhoneNumber;
function formatDate(value) {
    var djs = dayjs_1.default(value);
    if (djs.isValid()) {
        return djs.format('D MMM YYYY');
    }
    else {
        return '';
    }
}
exports.formatDate = formatDate;
function fromNow(value) {
    var djs = dayjs_1.default(value);
    if (djs.isValid()) {
        return djs.fromNow();
    }
    else {
        return '';
    }
}
exports.fromNow = fromNow;
function formatListAsSentence(inputArray) {
    var stringEnd = inputArray.splice(-2, 2).join(' & ');
    return [inputArray.join(', '), stringEnd].filter(Boolean).join(', ');
}
exports.formatListAsSentence = formatListAsSentence;
